import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { MaterialModal } from 'components/layout'
import { ReviseMessage } from 'containers/misc'
import { modal } from 'helpers/decorators'

@modal.trigger()
class ReviseMessageModal extends Component {
  static propTypes = {
    modalId: PropTypes.string,
    modalObj: PropTypes.object
  }

  render() {
    const { modalId, modalObj } = this.props
    const isRP = get(modalObj, 'data.residentialProject')

    return (
      <MaterialModal.Body
        id={modalId}
        title={'Revise Message'}
        titleKey={
          isRP ? 'moduleTitle.revise_message_rp' : 'moduleTitle.revise_message'
        }
      >
        <MaterialModal.Content noFooter>
          <ReviseMessage {...this.props} />
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}

export default ReviseMessageModal
